module.exports = __webpack_public_path__ + "Roboto-ThinItalic.64ca718f48db91b27e8c.eot";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-ThinItalic.eot
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-ThinItalic.eot
// module chunks = 13